import type {RootState} from "../store";

const empty: string[] = [];

function selectChapterSectionKeys(state: RootState, key: string): string[] {
	return state.chapterSections.byKey[key]?.sections ?? empty;
}

export default selectChapterSectionKeys;
